<template>
  <div>
    <div class="modal is-active">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{title}}</p>
          <button class="delete" aria-label="close" @click="$emit('close')"></button>
        </header>
        <section class="modal-card-body" :class="overflow ? 'overflow' : ''">
          <slot />
        </section>
        <footer class="modal-card-foot">
          <span class="field is-grouped">
            <slot name="buttons">
              <custom-button class="inline" modifier="primary" @click="$emit('submit')">Submit</custom-button>
              <custom-button class="inline margin-left-2" @click="$emit('close')">Cancel</custom-button>
            </slot>
          </span>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import customButton from "@/components/custom-button"

export default {
  name: "modal",
  components: {
    customButton
  },
  props: {
    title: String,
    overflow: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>